import { DirectionalLight } from 'three';

function createLights2() {
  // 创建一个强度为 10 的纯白光
  const light = new DirectionalLight('white', 10, 100);

  // 灯光从(50, 50, 50)照向(0,0,0)
  light.position.set( 50, 50, 50 );

  return light;
}

export { createLights2 };